export enum PurchaseStatus {
  'hold' = 3,
  'due' = 4,
  'completed' = 5,
  'cancelled' = 2,
}
